import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTABar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (documentHeight > 0 && scrollPosition / documentHeight > 0.3) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCheckout = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-304">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 md:bottom-auto md:top-[40px] z-40 bg-cream/95 backdrop-blur-md shadow-[0_-4px_20px_rgba(43,37,40,0.12)] md:shadow-[0_4px_20px_rgba(43,37,40,0.12)] border-t md:border-t-0 md:border-b border-soft/40" data-id="element-305">
          <div className="max-w-4xl mx-auto px-4 py-3 md:py-3 flex flex-row items-center justify-between gap-4" data-id="element-306">
            <p className="font-serif font-bold text-primary text-base md:text-lg hidden sm:block" data-id="element-307">
              Cierra el ciclo hoy →
            </p>
            <a href="#checkout" onClick={scrollToCheckout} className="w-full sm:w-auto text-center bg-gradient-to-br from-accent to-primary text-white font-sans font-extrabold py-2.5 px-6 rounded-full shadow-[0_4px_0_#3A1D2C,0_6px_15px_rgba(92,46,70,0.35)] hover:-translate-y-0.5 active:translate-y-1 active:shadow-[0_2px_0_#3A1D2C] transition-all text-sm md:text-base tracking-wide" data-id="element-308">
              QUIERO ACCEDER AHORA
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}